import React from 'react';
import { Box, Paper, Typography, IconButton, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { formatDate, formatHour } from '../../common/DateUtil';
import { parseISO, differenceInDays } from 'date-fns';

const ReservationTile = ({ reservation, onEdit, t }) => {
    const { fromDate, toDate, checkInHour, checkOutHour } = reservation;

    const nights =
        fromDate && toDate
            ? differenceInDays(parseISO(toDate), parseISO(fromDate))
            : 0;

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }} data-testid="reservation-tile">
            <Grid
                container
                alignItems="center"
                spacing={2}
            >
                {/* Nights */}
                <Grid item xs={3} sm={2}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="h5" color="primary" fontWeight={600} data-testid="reservation-nights">
                            {nights}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {t('nachten')}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {reservation.price}
                        </Typography>
                    </Box>
                </Grid>

                {/* Dates */}
                <Grid item xs={7} sm={8}>
                    <Box>
                        <Typography variant="body2" color="text.secondary" data-testid="reservation-check-in-info">
                            <strong>{t('checkIn')}:</strong> {formatDate(fromDate)} {formatHour(checkInHour)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" data-testid="reservation-check-out-info">
                            <strong>{t('checkOut')}:</strong> {formatDate(toDate)} {formatHour(checkOutHour)}
                        </Typography>

                        {reservation.stays.map((line, lineIndex) => (
                            <Typography key={lineIndex} display={'block'} variant="caption" color="text.secondary">
                                { line.name }
                            </Typography>
                        ))}
                    </Box>
                </Grid>

                {/* Actions */}
                {onEdit && (
                    <Grid item xs={2} sm={2} sx={{ textAlign: 'right' }}>
                        <IconButton size="small" onClick={() => onEdit(reservation)} data-testid="edit-reservation-icon-button">
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
};

export default ReservationTile;
